const getInitialState = () => ({
    openRequests: [],
    failedRequests: [],
    updatedAt: 0,
    targetActual: {
        entries: {},
        maxCount: 0,
    },
    lastInteractiveId: null,
});

export default {
    getInitialState
};
